import { ErrorToast } from "@ciq/shared/utils/toast"

/**
 * Default error handler for API requests that handles authentication and authorization errors.
 * Handles 401 (unauthorized) errors by showing an error toast.
 * Handles 403 (forbidden) errors by redirecting to the login URL provided in the error response.
 *
 * @param {Error} error - The error object from an axios request
 * @returns {boolean} Boolean indicating if the error was handled (true) or not (false)
 */
export const errorHandler = error => {
  if (!error || !error.response) return false

  const status = error.response.status

  if (status === 401) {
    ErrorToast("You do not have permissions to perform this action")
    return true
  }

  if (status === 403) {
    window.location = error.response.data.error.context.login_url
    return true
  }

  return false
}
